





































import { RootGettersReturns } from '@/store/types';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { BoardActionsKeys, BoardActionsPayload } from '@/store/types/board';
import EditLabel from './EditLabel.vue';
import DeleteLabel from './DeleteLabel.vue';

@Component({
  components: {
    EditLabel,
    DeleteLabel,
  },
})
export default class LabelManager extends Vue {
  @Getter labels!: RootGettersReturns['labels'];

  @Action(BoardActionsKeys.EDIT_LABEL) editLabel!: (payload: BoardActionsPayload['EDIT_LABEL']) => void;
  @Action(BoardActionsKeys.DELETE_LABEL) deleteLabel!: (payload: BoardActionsPayload['DELETE_LABEL']) => void;
}
